export enum AuthScreenMode {
    EmailOnly,
    Username,
}
